import { render, staticRenderFns } from "./UserBadgeNfc.vue?vue&type=template&id=5fed91ae&"
import script from "./UserBadgeNfc.vue?vue&type=script&lang=ts&"
export * from "./UserBadgeNfc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports